import {
  default as AdviceServices,
  AdviceServicesProps,
} from './sections/advice-services/advice-services';
import { CtaTppSectionWithNBR } from './sections/cta-tpp/cta-tpp';
import DecisionsSection, {
  DecisionsSectionProps,
} from './sections/decisions/decisions';
import {
  default as AdvicePageHeroSection,
  AdvicePageHeroSectionProps,
} from './sections/hero/hero';
import {
  HighlightProps,
  HighlightSection,
} from './sections/highlight/highlight';
import { ImageCardCtaProps } from './sections/image-card-cta/image-card-cta';
import {
  default as OfferingsSection,
  OfferingsSectionProps,
} from './sections/offerings/offerings';
import { AdvicePageRecognitionSection } from './sections/recognition/recognition';
import { ExplorationFlagsType } from '@exploration/feature-management';
import {
  NbrFilterProps,
  NbrFilterSectionEmbedded,
} from '@exploration/pages-needs-based';
import {
  WorkingWithUsPage,
  WorkingWithUsPageProps,
} from '@exploration/pages-working-with-us';
import { ConnectSectionProps } from '@exploration/shared-components';
import {
  CTAConnectionOptionsProps,
  ConnectSectionDeprecated,
  RecognitionSectionProps,
} from '@exploration/shared-sections';
import { HeadMetadata, NextPageWithLayout } from '@exploration/shared-types';
import { useTheme } from 'styled-components';

// --------------------------------------------------------------------------

export interface AdvicePageProps {
  flags: ExplorationFlagsType;
  metadata: HeadMetadata;
  heroSectionData: AdvicePageHeroSectionProps;
  offeringsData: OfferingsSectionProps;
  ctaTppData: ImageCardCtaProps;
  adviceServicesData: AdviceServicesProps;
  productHighlightData: HighlightProps;
  connectData: ConnectSectionProps;
  ctaConnectionOptionsData: CTAConnectionOptionsProps;
  recognitionSectionData?: RecognitionSectionProps;
  decisionsSectionData: DecisionsSectionProps;
  nbrSection: NbrFilterProps;
  workingWithUsPageData: WorkingWithUsPageProps;
}

// --------------------------------------------------------------------------

export const AdvicePage: NextPageWithLayout<AdvicePageProps> = ({
  flags,
  heroSectionData,
  offeringsData,
  ctaTppData,
  adviceServicesData,
  productHighlightData,
  connectData,
  ctaConnectionOptionsData,
  recognitionSectionData,
  decisionsSectionData,
  nbrSection,
  workingWithUsPageData,
}) => {
  const { midwestColors: colors } = useTheme();

  const wwuEmbedded = (
    <WorkingWithUsPage
      {...workingWithUsPageData}
      flags={flags}
      forceBreakpoint="mobile"
    />
  );

  return (
    <>
      <AdvicePageHeroSection
        workingWithUsPageComponent={wwuEmbedded}
        {...heroSectionData}
      />
      <OfferingsSection {...offeringsData} />

      <AdviceServices {...adviceServicesData} />

      <NbrFilterSectionEmbedded
        pillData={nbrSection.pillData}
        titleSectionData={nbrSection.titleSectionData}
        leftContentData={nbrSection.leftContentData}
        contentTabData={nbrSection.contentTabData}
        isEmbedded={true}
      />

      <CtaTppSectionWithNBR {...ctaTppData} />

      <ConnectSectionDeprecated
        withChatData={ctaConnectionOptionsData}
        withoutChatData={connectData}
        backgroundColor={colors.white}
      />

      <DecisionsSection {...decisionsSectionData} />

      <HighlightSection {...productHighlightData} />

      {recognitionSectionData && (
        <AdvicePageRecognitionSection {...recognitionSectionData} />
      )}
    </>
  );
};

export default AdvicePage;
